import Icon from '@/ui/Icon/Icon'
import { Tooltip } from '@/ui/Tooltip/Tooltip'
import { Body1 } from '@/ui/Typography'

import { useState } from 'react'
import styles from './FoilToolTip.module.scss'

export function FoilTooltip() {
  const [open, setOpen] = useState(false)
  return (
    <Tooltip open={open}>
      <Tooltip.Trigger onClick={() => setOpen((s) => !s)}>
        <button aria-label="Foil Help" onMouseOver={() => setOpen(true)} onMouseLeave={() => setOpen(false)}>
          <Icon name="question" size="md" className={styles.icon} />
        </button>
      </Tooltip.Trigger>
      <Tooltip.Content side="right" className={styles.content}>
        <Body1>
          Add a touch of luxury in gold, rose gold, or silver. Foil printing uses a heated die to hand-press metallic or
          pigmented foil onto paper for extra shine.
        </Body1>
      </Tooltip.Content>
    </Tooltip>
  )
}
